import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ArrowRightIcon, Clock } from 'lucide-react';
function CountdownDigit({
  value,
  label
}: {
  value: string;
  label: string;
}) {
  return <div className="flex flex-col items-center" data-id="element-394">
      <div className="relative bg-black/60 border border-[#C9A84C]/30 rounded-md px-1.5 py-0.5 md:px-2 md:py-1 min-w-[28px] md:min-w-[36px] text-center" data-id="element-395">
        <span className="text-sm md:text-lg font-black text-transparent bg-clip-text bg-gradient-to-b from-[#FFD700] to-[#C9A84C] tabular-nums" data-id="element-396">
          {value}
        </span>
        <div className="absolute inset-0 rounded-md bg-gradient-to-b from-white/5 to-transparent pointer-events-none" data-id="element-397" />
      </div>
      <span className="text-[7px] md:text-[8px] uppercase tracking-widest text-gray-500 mt-0.5 font-bold" data-id="element-398">
        {label}
      </span>
    </div>;
}
export function StickyOfferBar() {
  const [isVisible, setIsVisible] = useState(false);
  const [timeLeft, setTimeLeft] = useState(20 * 60); // 20 minutes in seconds
  useEffect(() => {
    const handleScroll = () => {
      const heroHeight = window.innerHeight;
      setIsVisible(window.scrollY > heroHeight * 0.8);
    };
    window.addEventListener('scroll', handleScroll, {
      passive: true
    });
    handleScroll();
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  useEffect(() => {
    if (timeLeft <= 0) return;
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev <= 1) {
          clearInterval(timer);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, [timeLeft]);
  const minutes = Math.floor(timeLeft / 60);
  const seconds = timeLeft % 60;
  const formattedMin = String(minutes).padStart(2, '0');
  const formattedSec = String(seconds).padStart(2, '0');
  const handleClick = () => {
    document.querySelector('#compra')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <AnimatePresence data-id="element-399">
      {isVisible && <motion.div initial={{
      y: -100,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: -100,
      opacity: 0
    }} transition={{
      duration: 0.4,
      ease: [0.16, 1, 0.3, 1]
    }} className="fixed top-0 left-0 right-0 z-50" data-id="element-400">
          <div className="border-b border-[#C9A84C]/40" style={{
        background: 'linear-gradient(0deg, rgba(10,10,10,0.95) 0%, rgba(15,12,8,0.98) 100%)',
        backdropFilter: 'blur(20px)'
      }} data-id="element-401">
            <div className="max-w-5xl mx-auto flex items-center justify-between px-3 py-1.5 md:py-2 gap-2" data-id="element-402">
              {/* Logo */}
              <img src="https://cdn.magicpatterns.com/uploads/oVduJGmSayLGnWM11iC4cN/Logo_Renova.png" alt="Renova Detail" width={120} height={32} className="h-6 md:h-8 object-contain flex-shrink-0" data-id="element-403" />

              {/* Countdown Timer */}
              <div className="flex items-center gap-2 md:gap-3" data-id="element-404">
                <Clock className="w-3 h-3 md:w-3.5 md:h-3.5 text-[#C9A84C]" data-id="element-405" />
                <span className="text-[9px] md:text-[10px] uppercase tracking-widest text-gray-400 font-bold hidden sm:inline" data-id="element-406">
                  Oferta expira en
                </span>
                <div className="flex items-center gap-1" data-id="element-407">
                  <CountdownDigit value={formattedMin} label="min" data-id="element-408" />
                  <span className="text-[#C9A84C] font-black text-sm md:text-lg animate-pulse mb-2.5 md:mb-3" data-id="element-409">
                    :
                  </span>
                  <CountdownDigit value={formattedSec} label="seg" data-id="element-410" />
                </div>
              </div>

              {/* CTA Button */}
              <motion.button onClick={handleClick} animate={{
            boxShadow: ['0 0 15px rgba(245,197,24,0.3), 0 0 30px rgba(245,197,24,0.1)', '0 0 25px rgba(245,197,24,0.5), 0 0 50px rgba(245,197,24,0.2)', '0 0 15px rgba(245,197,24,0.3), 0 0 30px rgba(245,197,24,0.1)']
          }} transition={{
            duration: 2,
            repeat: Infinity,
            ease: 'easeInOut'
          }} whileHover={{
            scale: 1.05,
            y: -1
          }} whileTap={{
            scale: 0.95
          }} className="relative overflow-hidden flex items-center gap-2 px-5 md:px-8 py-2 md:py-2.5 rounded-xl font-black text-xs md:text-sm uppercase tracking-wider text-black cursor-pointer border-b-2 border-[#B8860B] transition-all duration-300" style={{
            background: 'linear-gradient(135deg, #F5C518 0%, #FFD700 50%, #E5B800 100%)'
          }} data-id="element-411">
                <span className="relative z-10 whitespace-nowrap" data-id="element-412">
                  QUIERO MI FORMACIÓN
                </span>
                <motion.div animate={{
              x: [0, 4, 0]
            }} transition={{
              duration: 1.2,
              repeat: Infinity,
              ease: 'easeInOut'
            }} className="relative z-10" data-id="element-413">
                  <ArrowRightIcon className="w-4 h-4 md:w-5 md:h-5" data-id="element-414" />
                </motion.div>
                {/* Refined shine effect */}
                <div className="absolute top-0 -inset-full h-full w-1/2 z-5 block transform -skew-x-12 bg-gradient-to-r from-transparent via-white/60 to-transparent opacity-0 group-hover:opacity-100 animate-[shine_1.5s_infinite] pointer-events-none" data-id="element-415" />
                <div className="absolute inset-0 bg-gradient-to-t from-black/5 to-white/10 pointer-events-none" data-id="element-416" />
              </motion.button>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}